'use client';

import React, { createContext, useContext, useState, useCallback } from 'react';

interface MessageRefreshContextType {
  triggerRefresh: () => void;
  refreshTrigger: number;
}

const MessageRefreshContext = createContext<MessageRefreshContextType | undefined>(undefined);

export const MessageRefreshProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const triggerRefresh = useCallback(() => {
    setRefreshTrigger((prev) => prev + 1);
  }, []);

  return (
    <MessageRefreshContext.Provider value={{ triggerRefresh, refreshTrigger }}>
      {children}
    </MessageRefreshContext.Provider>
  );
};

export const useMessageRefresh = () => {
  const context = useContext(MessageRefreshContext);
  if (!context) {
    throw new Error('useMessageRefresh must be used within MessageRefreshProvider');
  }
  return context;
};
